import PropTypes from 'prop-types'

/**
 * @typedef {Object} erucMatch
 *
 * @property {string}  [accountId]   - eRuc account id
 * @property {string}  [accountName] - eRuc account name
 */
export const erucMatchPropType = PropTypes.shape({
    rucMonkeyLicensePlate: PropTypes.string.isRequired,
    webfleetObjectId: PropTypes.string
})
